import React, { useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { IconShoppingCartCancel } from "@tabler/icons-react";
import { useLocaleNavigate } from "@ct-react/locale";
import { cartTranslations } from "../../../i18n/sharable-defs";
import { useInterhomeContext } from "./interhome-outlet";
import SuccessSvg from "../../../assets/componable-svgs/succeeded-payment.svg";

const transDefs = defineMessages({
  success: { id: "interhome-callback-success-title", defaultMessage: "Réservation terminée" },
  successText: { id: "interhome-callback-success-text", defaultMessage: "Merci pour votre réservation. Interhome se fera un plaisir de vous recevoir" },
  failure: { id: "interhome-callback-failure-title", defaultMessage: "Paiement annulé" },
  failureText: { id: "interhome-callback-failure-text", defaultMessage: "Vous avez annulé le processus de paiement. Votre réservation reste en attente auprès d'Interhome jusqu'à confirmation." }
});

const InterhomePaymentCallback = ({ succeeded }: { succeeded: boolean }) => {

  const intl = useIntl();
  const navigate = useLocaleNavigate();
  const [ _, dispatch ] = useInterhomeContext();

  useEffect(() => dispatch({ type: "change.index", payload: 2}), []);

  return (
    <div className="cart-item-wrapper callback">
      <div className="result">
        <h1>{intl.formatMessage(succeeded ? transDefs.success : transDefs.failure)}</h1>
        {succeeded ? <SuccessSvg className="success-svg" /> : <IconShoppingCartCancel />}
        <p>{intl.formatMessage(succeeded ? transDefs.successText : transDefs.failureText)}</p>
      </div>
      <div className="stepper-actions">
        <button className="back step-btn"
                type="button"
                onClick={() => navigate("/")}>
          {intl.formatMessage(cartTranslations.backHome)}
        </button>
      </div>
    </div>);

};

export default InterhomePaymentCallback;
